import React from 'react';
import DataGrid from '../../../../../table/DataGrid';
import IconTooltipButton from '../../../../../button/IconTooltipButton';

const List = ({ isLoading, list, permissions, onAction }) => {
  const columnsTable = [
    {
      show: true,
      key: 'code',
      align: 'center',
      hide: false,
      width: 1,
      label: 'value'
    },
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Name'
    },
    {
      show: permissions['preview'] || permissions['updated'] || permissions['deleted'],
      key: 'actions',
      align: 'center',
      hide: false,
      width: 3,
      label: 'actions'
    }
  ];

  return (
    <DataGrid
      id='marking-curriculum'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      rows={list.map((row) => {
        return {
          ...row,
          code: <div className='flex items-center justify-center py-1'>
            <div 
          className='size-10 flex items-center justify-center bg-muted text-muted-foreground rounded-full'
          style={{
            backgroundColor: row.primaryColor ? row.primaryColor : 'currentcolor',
            color: row.secondaryColor ? row.secondaryColor : 'currentcolor'
          }}
        >
          {row.value}
        </div>
        </div>,
          primary: (
            <div>
              <p>{row.name}</p>
              <p className='text-xs text-muted-foreground opacity-50'>{row.description}</p>
            </div>
          ),
          actions: (
            <div>
              {permissions['preview'] && (
                <IconTooltipButton
                  title='Preview'
                  icon='expand-alt'
                  onClick={() => onAction('preview', row)}
                />
              )}
              {permissions['updated'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onAction('edit', row)}
                />
              )}
              {permissions['deleted'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onAction('delete', row)}
                />
              )}
            </div>
          )
        };
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any marking yet"
    />
  );
};

export default List;
